import { render, staticRenderFns } from "./productData.vue?vue&type=template&id=71e94521&"
import script from "./productData.vue?vue&type=script&lang=js&"
export * from "./productData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports